exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-table[data-v-290c004f] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-290c004f] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-290c004f] {\n  display: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-290c004f","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/simulate/doubleQianNiuExam.vue
// module id = 1404
// module chunks = 0